import ConstructionBrick from './../../../../assets/icons/parameters/default/construction-brick.svg';
import ConstructionMix from './../../../../assets/icons/parameters/default/construction-mix.svg';
import ConstructionPanel from './../../../../assets/icons/parameters/default/construction-panel.svg';
import ConstructionPrefabWood from './../../../../assets/icons/parameters/default/construction-prefab-wood.svg';
import ConstructionPrefab from './../../../../assets/icons/parameters/default/construction-prefab.svg';
import ConstructionSkeleton from './../../../../assets/icons/parameters/default/construction-skeleton.svg';
import ConstructionStone from './../../../../assets/icons/parameters/default/construction-stone.svg';
import ConstructionTimber from './../../../../assets/icons/parameters/default/construction-timber.svg';
import ConstructionWood from './../../../../assets/icons/parameters/default/construction-wood.svg';
import Other from './../../../../assets/icons/parameters/default/other.svg';

import Electricity120V from './../../../../assets/icons/parameters/default/electricity-120v.svg';
import Electricity230v400V from './../../../../assets/icons/parameters/default/electricity-230v-400v.svg';
import Electricity230V from './../../../../assets/icons/parameters/default/electricity-230v.svg';
import ElectricityDisconnected from './../../../../assets/icons/parameters/default/electricity-disconnected.svg';
import ElectricityNone from './../../../../assets/icons/parameters/default/electricity-none.svg';

import EquipmentAirConditioning from './../../../../assets/icons/parameters/default/equipment-air-conditioning.svg';
import EquipmentAntennaWiring from './../../../../assets/icons/parameters/default/equipment-antenna-wiring.svg';
import EquipmentBuiltInCloset from './../../../../assets/icons/parameters/default/equipment-built-in-closet.svg';
import EquipmentCentralVacuumCleaner from './../../../../assets/icons/parameters/default/equipment-central-vacuum-cleaner.svg';
import EquipmentFireplace from './../../../../assets/icons/parameters/default/equipment-fireplace.svg';
import EquipmentKitchenHood from './../../../../assets/icons/parameters/default/equipment-kitchen-hood.svg';
import EquipmentMotionAlarm from './../../../../assets/icons/parameters/default/equipment-motion-alarm.svg';
import EquipmentNetworkWiring from './../../../../assets/icons/parameters/default/equipment-network-wiring.svg';
import EquipmentNone from './../../../../assets/icons/parameters/default/equipment-none.svg';
import EquipmentVentilatorSystem from './../../../../assets/icons/parameters/default/equipment-ventilator-system.svg';
import EquipmentWindowBars from './../../../../assets/icons/parameters/default/equipment-window-bars.svg';

import GasIndividual from './../../../../assets/icons/parameters/default/gas-individual.svg';
import GasNo from './../../../../assets/icons/parameters/default/gas-no.svg';
import GasPipeline from './../../../../assets/icons/parameters/default/gas-pipeline.svg';
import GasYes from './../../../../assets/icons/parameters/default/gas-yes.svg';

import OwnershipOther from './../../../../assets/icons/parameters/default/other.svg';
import OwnershipCooperative from './../../../../assets/icons/parameters/default/ownership-cooperative.svg';
import Ownership from './../../../../assets/icons/parameters/default/ownership-personal.svg';

import SewerageDrain from './../../../../assets/icons/parameters/default/sewerage-drain.svg';
import SewerageNone from './../../../../assets/icons/parameters/default/sewerage-none.svg';
import SeweragePublic from './../../../../assets/icons/parameters/default/sewerage-public.svg';
import SewerageSeptic from './../../../../assets/icons/parameters/default/sewerage-septic.svg';
import SewerageSumps from './../../../../assets/icons/parameters/default/sewerage-sump.svg';
import SewerageTreatmentPlant from './../../../../assets/icons/parameters/default/sewerage-treatment-plant.svg';

import StateAfterReconstruction from './../../../../assets/icons/parameters/default/state-after-reconstruction.svg';
import StateBad from './../../../../assets/icons/parameters/default/state-bad.svg';
import StateBeforeReconstruction from './../../../../assets/icons/parameters/default/state-before-reconstruction.svg';
import StateGood from './../../../../assets/icons/parameters/default/state-good.svg';
import StateLuxury from './../../../../assets/icons/parameters/default/state-luxury.svg';
import StateNew from './../../../../assets/icons/parameters/default/state-new.svg';
import StateProject from './../../../../assets/icons/parameters/default/state-project.svg';
import StateToDemolition from './../../../../assets/icons/parameters/default/state-to-demolition.svg';
import StateUnderConstruction from './../../../../assets/icons/parameters/default/state-under-construction.svg';
import StateVeryGood from './../../../../assets/icons/parameters/default/state-very-good.svg';

import WaterLocalSource from './../../../../assets/icons/parameters/default/water-local-source.svg';
import WaterNone from './../../../../assets/icons/parameters/default/water-none.svg';
import WaterSupply from './../../../../assets/icons/parameters/default/water-supply.svg';
import WaterWell from './../../../../assets/icons/parameters/default/water-well.svg';

import ToiletEquipmentBidet from './../../../../assets/icons/parameters/default/toiletEquipment-bidet.svg';
import ToiletEquipmentClassicToilet from './../../../../assets/icons/parameters/default/toiletEquipment-classic-toilet.svg';
import ToiletEquipmentNone from './../../../../assets/icons/parameters/default/toiletEquipment-none.svg';
import ToiletEquipmentSink from './../../../../assets/icons/parameters/default/toiletEquipment-sink.svg';
import ToiletEquipmentWallMountedToilet from './../../../../assets/icons/parameters/default/toiletEquipment-wall-mounted-toilet.svg';

import KitchenEquipmentCeramicHob from './../../../../assets/icons/parameters/default/kitchenEquipment-ceramic-hob.svg';
import KitchenEquipmentCombinedStove from './../../../../assets/icons/parameters/default/kitchenEquipment-combined-stove.svg';
import KitchenEquipmentElectricStove from './../../../../assets/icons/parameters/default/kitchenEquipment-electric-stove.svg';
import KitchenEquipmentFittedKitchenWithAppliances from './../../../../assets/icons/parameters/default/kitchenEquipment-fitted-kitchen-with-appliances.svg';
import KitchenEquipmentFittedKitchen from './../../../../assets/icons/parameters/default/kitchenEquipment-fitted-kitchen.svg';
import KitchenEquipmentGasStove from './../../../../assets/icons/parameters/default/kitchenEquipment-gas-stove.svg';
import KitchenEquipmentInductionHob from './../../../../assets/icons/parameters/default/kitchenEquipment-induction-hob.svg';
import KitchenEquipmentNone from './../../../../assets/icons/parameters/default/kitchenEquipment-none.svg';
import KitchenEquipmentPartlyFittedKitchenWithAppliances from './../../../../assets/icons/parameters/default/kitchenEquipment-partly-fitted-kitchen-with-appliances.svg';

import BathroomEquipmentClassicBathtub from './../../../../assets/icons/parameters/default/bathroomEquipment-classic-bathtub.svg';
import BathroomEquipmentCornerBathtub from './../../../../assets/icons/parameters/default/bathroomEquipment-corner-bathtub.svg';
import BathroomEquipmentLuxuryBathtub from './../../../../assets/icons/parameters/default/bathroomEquipment-luxury-bathtub.svg';
import BathroomEquipmentNone from './../../../../assets/icons/parameters/default/bathroomEquipment-none.svg';
import BathroomEquipmentShower from './../../../../assets/icons/parameters/default/bathroomEquipment-shower.svg';
import BathroomEquipmentSink from './../../../../assets/icons/parameters/default/bathroomEquipment-sink.svg';

export default {
    'buildingState-after_reconstruction': StateAfterReconstruction,
    'buildingState-bad': StateBad,
    'buildingState-before_reconstruction': StateBeforeReconstruction,
    'buildingState-good': StateGood,
    'buildingState-luxury': StateLuxury,
    'buildingState-new': StateNew,
    'buildingState-project': StateProject,
    'buildingState-to_demolition': StateToDemolition,
    'buildingState-under_construction': StateUnderConstruction,
    'buildingState-very_good': StateVeryGood,
    'construction-brick': ConstructionBrick,
    'construction-mix': ConstructionMix,
    'construction-other': Other,
    'construction-panel': ConstructionPanel,
    'construction-prefab': ConstructionPrefab,
    'construction-prefab_wood': ConstructionPrefabWood,
    'construction-skeleton': ConstructionSkeleton,
    'construction-stone': ConstructionStone,
    'construction-timber': ConstructionTimber,
    'construction-wood': ConstructionWood,
    'electricity-120V': Electricity120V,
    'electricity-230V': Electricity230V,
    'electricity-230V+400V': Electricity230v400V,
    'electricity-other': Other,
    'electricity-none': ElectricityNone,
    'electricity-disconnected': ElectricityDisconnected,
    'equipment-air_conditioning': EquipmentAirConditioning,
    'equipment-antenna_wiring': EquipmentAntennaWiring,
    'equipment-built_in_closet': EquipmentBuiltInCloset,
    'equipment-central_vacuum_cleaner': EquipmentCentralVacuumCleaner,
    'equipment-fireplace': EquipmentFireplace,
    'equipment-kitchen_hood': EquipmentKitchenHood,
    'equipment-motion_alarm': EquipmentMotionAlarm,
    'equipment-network_wiring': EquipmentNetworkWiring,
    'equipment-none': EquipmentNone,
    'equipment-other': Other,
    'equipment-ventilator_system': EquipmentVentilatorSystem,
    'equipment-window_bars': EquipmentWindowBars,
    'gas-individual': GasIndividual,
    'gas-no': GasNo,
    'gas-pipeline': GasPipeline,
    'gas-yes': GasYes,
    'ownership-cooperative': OwnershipCooperative,
    'ownership-other': OwnershipOther,
    'ownership-personal': Ownership,
    'sewerage-drain': SewerageDrain,
    'sewerage-none': SewerageNone,
    'sewerage-other': Other,
    'sewerage-public': SeweragePublic,
    'sewerage-septic': SewerageSeptic,
    'sewerage-sump': SewerageSumps,
    'sewerage-treatment_plant': SewerageTreatmentPlant,
    'state-after_reconstruction': StateAfterReconstruction,
    'state-bad': StateBad,
    'state-before_reconstruction': StateBeforeReconstruction,
    'state-good': StateGood,
    'state-luxury': StateLuxury,
    'state-new': StateNew,
    'state-project': StateProject,
    'state-to_demolition': StateToDemolition,
    'state-under_construction': StateUnderConstruction,
    'state-very_good': StateVeryGood,
    'water-local_source': WaterLocalSource,
    'water-none': WaterNone,
    'water-other': Other,
    'water-supply': WaterSupply,
    'water-well': WaterWell,
    'toiletEquipment-bidet': ToiletEquipmentBidet,
    'toiletEquipment-classic_toilet': ToiletEquipmentClassicToilet,
    'toiletEquipment-none': ToiletEquipmentNone,
    'toiletEquipment-other': Other,
    'toiletEquipment-sink': ToiletEquipmentSink,
    'toiletEquipment-wall_mounted_toilet': ToiletEquipmentWallMountedToilet,
    'kitchenEquipment-electric_stove': KitchenEquipmentElectricStove,
    'kitchenEquipment-fitted_kitchen': KitchenEquipmentFittedKitchen,
    'kitchenEquipment-fitted_kitchen_with_appliances': KitchenEquipmentFittedKitchenWithAppliances,
    'kitchenEquipment-gas_stove': KitchenEquipmentGasStove,
    'kitchenEquipment-none': KitchenEquipmentNone,
    'kitchenEquipment-other': Other,
    'kitchenEquipment-ceramic_hob': KitchenEquipmentCeramicHob,
    'kitchenEquipment-combined_stove': KitchenEquipmentCombinedStove,
    'kitchenEquipment-induction_hob': KitchenEquipmentInductionHob,
    'kitchenEquipment-partly_fitted_kitchen_with_appliances': KitchenEquipmentPartlyFittedKitchenWithAppliances,
    'bathroomEquipment-classic_bathtub': BathroomEquipmentClassicBathtub,
    'bathroomEquipment-corner_bathtub': BathroomEquipmentCornerBathtub,
    'bathroomEquipment-luxury_bathtub': BathroomEquipmentLuxuryBathtub,
    'bathroomEquipment-none': BathroomEquipmentNone,
    'bathroomEquipment-shower': BathroomEquipmentShower,
    'bathroomEquipment-sink': BathroomEquipmentSink,
    'bathroomEquipment-other': Other,
};
